export enum SortActivity
{
	BaseSort = 1,
	PlusActivity = 2,
	PremActivity = 3,
	CustActivity = 4,
	BlockRepairs = 5,
	MulticolorSort = 6,
	MulticolorRepairs = 7,
	HeatTreatment = 8,
	PalletWashAi = 9,
	PalletWashAr = 10,
	PlantMo = 11,
	StorageMo = 12,
	RadTransfers = 13,
	NailMaintenancePctAr = 14,
	NailMaintenanceDirect = 15,
	NailMaintenancePctArRu = 16,
	BlockReconstruction = 17,
	TpmMaintenanceOnly = 18,
	PecoRepairs = 19,
	TpmActivity = 20,
	IgpsActivity = 21

}
